import { render, staticRenderFns } from "./HospitalNotifications.vue?vue&type=template&id=398658c6&scoped=true"
import script from "./HospitalNotifications.vue?vue&type=script&lang=js"
export * from "./HospitalNotifications.vue?vue&type=script&lang=js"
import style0 from "./HospitalNotifications.vue?vue&type=style&index=0&id=398658c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398658c6",
  null
  
)

export default component.exports